import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { updateTeacherInfo, updateWaitingTimeAction } from '../../../redux/states/docente'
import { useTicket } from '../../../hooks/useTicket'
import { typeChecks } from 'data/constants'
import { Button, Form, Spinner } from 'react-bootstrap'
import { formatDate } from 'utils'

function ModalNotification() {
    const [time, setTime] = useState('')
    const infoTimerGlobal = useSelector((store) => store.teacher.infoTimer)
    const infoTimer = useSelector((store) => store.teacher.infoTimer)
    const [codeInput, setCodeInput] = useState('')
    const dispatch = useDispatch()
    const [isFinished, setIsFinished] = useState(false)
    const { sendTicket, loadingTicket } = useTicket()

    useEffect(() => {
        let interval = setInterval(() => {
            setTime(formatDate(new Date(), 'H:i:s'))
        }, 1000)
        return () => {
            clearInterval(interval)
        }
    }, [])

    useEffect(() => {
        updateWaitingTime()
    }, [time])

    /**
     * Actualiza el temporizador
     */
    const updateWaitingTime = () => {
        if (infoTimerGlobal.timeRemaning === '00:00') {
            if (!isFinished) {
                const infoTimer = {
                    infoTimer: {
                        active: false,
                        time: '',
                    },
                    activeNotification: false,
                }
                setTimeout(() => {
                    dispatch(updateTeacherInfo(infoTimer))
                    window.close()
                }, 1000)
                setIsFinished(true)
            }
        } else {
            let currentWaitingTime = infoTimerGlobal.timeRemaning //hh:mm:ss
            let second = Number(currentWaitingTime.slice(3, 5))
            let minute = Number(currentWaitingTime.slice(0, 2))
            if (second === 0) {
                second = 59
                minute = minute - 1
                if (minute === 0) {
                    minute = 0
                }
            } else {
                second--
            }

            const formatDigit = (digit) => (digit < 10 ? `0${digit}` : digit)
            const timeRemaning = `${formatDigit(minute)}:${formatDigit(second)}`
            dispatch(updateWaitingTimeAction({ timeRemaning }))
        }
    }

    /**
     * Maneja la confirmacion del codigo ingresado.
     */
    const handleConfirmCode = async () => {
        if (codeInput === infoTimerGlobal.code) {
            const time = infoTimerGlobal.time
            const infoTimer = {
                activeNotification: false,
                infoTimer: {
                    active: false,
                    time: time,
                    id: null,
                },
            }
            await sendTicket(true, typeChecks.CONTROLPERMANENCIA, infoTimerGlobal.id)
            dispatch(updateTeacherInfo(infoTimer))
            setCodeInput('')
            window.close()
        } else {
            toast.error('Código incorrecto!')
        }
    }

    return (
        <div className='py-3 px-5 text-center'>
            <div className='fs-2 mb-3'>
                <span style={{ borderBottom: '2px solid #000' }}>Control de permanencia</span>
            </div>
            {infoTimerGlobal?.active && (
                <>
                    <p className='text-center fs-5'>
                        Ingrese el código: <span className='fw-medium'>{infoTimerGlobal.code}</span>
                    </p>
                    <div className='mb-3 d-flex gap-3'>
                        <Form.Control
                            value={codeInput}
                            onChange={(e) => setCodeInput(e.target.value.toUpperCase())}
                            onKeyUp={(e) => {
                                e.key === 'Enter' && handleConfirmCode()
                            }}
                            placeholder='Código'
                        />
                        {loadingTicket ? (
                            <Spinner size='sm' variant='blue' />
                        ) : (
                            <Button variant='blue' onClick={handleConfirmCode}>
                                Confirmar
                            </Button>
                        )}
                    </div>
                    <span className='fs-5'>Tiempo restante: {infoTimer.timeRemaning}</span>
                </>
            )}
        </div>
    )
}
export default ModalNotification
